/* eslint-disable require-await */
import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { Field } from 'formik';
import debounce from 'lodash/debounce';
import { defaultDeleteFilter } from 'utils/constants';
import FormikAsyncCreatableSelect from 'components/Fields/FormikAsyncCreatableSelect';
import { GRADES_QUERY } from '../../constants';

const GradeSelectFilter = ({ statusFilter, ...props }) => {
  const [grades] = useLazyQuery(GRADES_QUERY);
  const [isLoading, setisLoading] = useState(false);
  const loadOptions = async (inputValue, callback) => {
    if (!inputValue) {
      return [];
    }

    try {
      setisLoading(true);
      const { data } = await grades({
        variables: {
          filter: [
            {
              key: 'name',
              value: inputValue,
              type: 'STRING',
              op: 'LIKE',
            },
            { ...defaultDeleteFilter },
            statusFilter,
          ],
          pagination: false,
        },
      });

      callback(data?.grades?.grades);
      setisLoading(false);
    } catch (error) {
      console.error('Error fetching options:', error);
      callback([]);
      setisLoading(false);
    }
  };

  const handleDebounce = debounce(async (inputValue, callback) => {
    loadOptions(inputValue, callback);
  }, 1000);

  return (
    <div>
      <Field
        type="text"
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.name}
        keys={{ id: 'id', label: 'label' }}
        loadOptions={handleDebounce}
        component={FormikAsyncCreatableSelect}
        isLoading={isLoading}
        isClearable
        isSearchable
        getNewOptionData={(newValue) => {
          if (newValue) {
            return {
              id: newValue,
              name: newValue,
            };
          }
        }}
        {...props}
      />
    </div>
  );
};

export default GradeSelectFilter;
